import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const ChoiceSelect = ({ value, onChange, options, testid, className = "", style }) => (
  <Select value={String(value)} onValueChange={onChange}>
    <SelectTrigger className={`h-auto py-2.5 rounded-xl border-0 text-sm ${className}`} style={{ background: "var(--mf-muted)", ...style }} data-testid={testid}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="z-[70] max-h-72">
      {options.map((o) => (
        <SelectItem key={o.value} value={String(o.value)} data-testid={`${testid}-opt-${o.value}`}>{o.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
